import './PageContent.css';

import { ReactNode, useEffect } from 'react';
import { IonPage } from '@ionic/react';
import { useRouteTransitionContext } from '../../hooks/context/useRouteTransitionContext';

interface PageContentProps {
  children?: ReactNode;
  className?: string;
  isLoading?: boolean;
}

// Content-only page wrapper for logged-in routes. The Header + Sidebar live once in the persistent shell
// (LoggedInLayout), so a page renders just its own scrollable content here. Stays an IonPage so Ionic
// route transitions keep working.
const PageContent = ({ children, className = '', isLoading }: PageContentProps) => {
  const { requestBusy, releaseBusy } = useRouteTransitionContext();

  // Keep the shared route-transition overlay up until this page finishes loading (incl. redirects).
  useEffect(() => {
    if (!isLoading) {
      return;
    }
    requestBusy();
    return releaseBusy;
  }, [isLoading, requestBusy, releaseBusy]);

  return (
    <IonPage className={className}>
      <div className="page-content-container">{!isLoading && children}</div>
    </IonPage>
  );
};

export default PageContent;
